var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-horizontal"},_vm._l((_vm.infos),function(info){return _c('ImageUploader',{key:info.url,attrs:{"info":info}})}))}
var staticRenderFns = []

export { render, staticRenderFns }